import resumeImg from "@/assets/cvbuildLogo.webp"; 
import { useNavigate } from "react-router-dom";

export default function ResumeBuilderSection() {
  const navigate = useNavigate();

  return (
    <section className="w-full bg-white py-10 md:py-14">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center gap-10">

          {/* Left Content */}
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 leading-snug">
              Build Your <span className="text-blue-600">Professional Resume</span>
              <br /> for Free
            </h2>

            <p className="mt-3 text-base text-gray-600 max-w-md">
              Create a modern, ATS-friendly resume in minutes. Choose a template,
              add your details, and download instantly.
            </p>

            {/* Features */}
            <ul className="mt-5 space-y-3 text-gray-700 text-sm">
              <li className="flex items-start gap-3">
                <span className="mt-2 h-2 w-2 rounded-full bg-blue-600"></span>
                Multiple professional templates
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-2 h-2 w-2 rounded-full bg-blue-600"></span>
                Step-by-step resume builder
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-2 h-2 w-2 rounded-full bg-blue-600"></span>
                Instant PDF download
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-2 h-2 w-2 rounded-full bg-blue-600"></span>
                100% free forever
              </li>
            </ul>

            {/* CTA */}
            <button
              onClick={() => navigate("/resume-templates")}
              className="mt-6 px-6 py-3 text-sm font-semibold text-white
              rounded-lg bg-gradient-to-r from-blue-600 to-blue-900
              hover:opacity-90 transition-all"
            >
              Create Resume Now
            </button>
          </div>

          {/* Right Image */}
          <div className="flex-1 flex justify-center">
            <img
              src={resumeImg}
              alt="Resume Builder"
              className="w-full max-w-md"
            />
          </div>

        </div>
      </div>
    </section>
  );
}
